<div class="container-fluid justify-content-center section mb-3">
  <div class="d-flex flex-column">
    <div class="d-flex flex-row justify-content-between mt-4 mb-3">
      <div class="title"> My recent blogs</div>
      <div class="blog-text-2 pt-1" *ngIf="blogs.length && blogs.length==3" [routerLink]="['/blog-listing']" [queryParams]="{ midwifeId: midwife.midwifeId}">
        VIEW ALL <i class="fas fa-long-arrow-alt-right arrow-icon ml-2"></i></div>

    </div>
    <div class="row justify-content-center" *ngIf="blogs.length">
      <div class="col-lg-4 mb-3 d-flex flex-column blog-detail" *ngFor="let blog of blogs" 
      [routerLink]="['/blog-detail', blog.postId]">
        <img *ngIf="blog.image" class="blog-img" [src]="blog.image" alt="">
        <img *ngIf="!blog.image" class="blog-img" src="../../../../../assets/Images/blog-not-found.png" alt="">
        <div class="blog-date mt-2 mb-2">{{blog?.createdAt | date:'EEE dd MMM, yyyy'}}</div>
        <div class="blog-title mt-1 mb-1">
          {{blog?.title}}
        </div>
        <div class="blog-content mb-2">
          {{blog?.body | slice:0:180}}
        </div>
      </div>
    </div>
    <div class="no-data" *ngIf="!blogs.length">
      <img class="align-self-center" src="../../../../../assets/Images/NoDocuments.png" height="50" width="80"
        alt="No Blogs">
      <span>No Blogs</span>
    </div>
  </div>
</div>